import React from "react";
import { useTranslation } from "react-i18next";
import PathLink from "../../shared/seo/PathLink";
import { contentPath } from "./contentLinks";
import "./content.css";

// "Related": guides and editorial FAQ on the same topic.
export default function RelatedBlock({ items, title }) {
  const { t } = useTranslation();
  if (!items || items.length === 0) return null;
  return (
    <section className="avc-related" aria-labelledby="avc-related-title">
      <h2 className="avc-related__title" id="avc-related-title">
        {title || t("related_title")}
      </h2>
      <ul className="avc-related__list">
        {items.map((item) => (
          <li key={`${item.kind}-${item.id}`} className="avc-related__item">
            <span className="avc-related__kind">
              <i className={item.kind === "faq" ? "far fa-question-circle" : "far fa-file-alt"} aria-hidden="true"></i>
              {t(item.kind === "faq" ? "related_kind_faq" : "related_kind_guide")}
            </span>
            <PathLink to={contentPath(item)} className="avc-related__link" dir="auto">
              {item.title}
            </PathLink>
          </li>
        ))}
      </ul>
    </section>
  );
}
